import { render } from "./ERPLayout.vue?vue&type=template&id=35f3c171&scoped=true&ts=true"
import script from "./ERPLayout.vue?vue&type=script&lang=ts"
export * from "./ERPLayout.vue?vue&type=script&lang=ts"

import "./ERPLayout.vue?vue&type=style&index=0&id=35f3c171&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f3c171"]])

export default __exports__